import React from "react";

const Aboutawardscelebrations = () => {
    return (
        <div id="hs_cos_wrapper_widget_1719384527279" className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_module" style={{ background: '#fff', justifyContent: 'center', width: '100%', marginTop: '-20px' }}>
            <style>
                {`
          .text-container {
            padding: 0;
          }

          .editor-wrapper {
            margin: 20px 0;
          }

        //   .container {
        //     max-width: 1200px;
        //     margin: 0 auto;
        //     padding: 20px;
        //   }

          .editor-wrapper p {
            font-size: 16px;
            line-height: 1.6;
            color: #333;
          }

          .editor-wrapper strong {
            font-weight: bold;
          }

          .editor-wrapper img {
            max-width: 100%;
            height: auto;
          }

          .editor-wrapper img[src*="box-mosule-img.png"] {
            margin-top: 20px;
          }
        `}
            </style>
            <br></br>
            <h1 style={{ textAlign: 'center' }}>Celebrating <span style={{ color: 'rgb(15 128 155)' }}> Excellence and Innovation</span></h1>
            <div className="row text-container widget_1719384527279" style={{ width: '100%', justifyContent: "center" }}>

                <div className="editor-wrapper">
                    <div className="container">
                        <p style={{ textAlign: 'center', fontWeight: 'bold' }}>
                            We are proud of the recognition received from our customers, industry bodies, and analysts. These awards highlight our commitment to excellence, innovation, and customer satisfaction and fostering a holistic workplace. They reflect our dedication to delivering value through Intelligent Engineering for a digital, autonomous, and sustainable future. Each accolade strengthens our trusted partner and industry leader position, inspiring us to continue pushing boundaries.

                            Recognized By Global Analysts & Advisor
                            Celebrating Excellence across Industries
                        </p>


                    </div>
                </div>
            </div>
        </div>
    );
};

export default Aboutawardscelebrations;
